import guest from "./guest";
import room from "./room";
import maintenance from "./maintenance";
import extracharge from "./extracharge";
import checkin from "./check-in";
import checkout from "./check-out";
import housekeeping from "./housekeeping";
import inventory from "./inventory";
import report from "./report";
import reservation from "./reservation";
import inHouse from "./in-house";
import admin from "./admin";
import test from "./test";
import staff from "./staff";
import roomCategory from "./room-category";
import technician from "./technician";
import staffPosition from "./staff-position";
import maintenanceIssue from "./maintenance-issue";
import roomStatus from "./room-status";
import vendor from "./vendor";
import paymentMethod from "./payment-method";
import extrachargeCategory from "./extracharge-category";
import source from "./source";
import roomManagement from "./room-management";
import login from "./login";
const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboard/DashboardIndex.vue"),
    meta: {
      layout: "default",
      role: [
        "superadmin",
        "backoffice",
        "supervisor",
        "receptionist",
        "housekeeping",
        "maintenance",
      ],
      public: false,
    },
  },
  ...login,
  ...guest,
  ...room,
  ...maintenance,
  ...extracharge,
  ...checkin,
  ...checkout,
  ...housekeeping,
  ...inventory,
  ...inHouse,
  ...admin,
  ...test,
  ...staff,
  ...report,
  ...reservation,
  ...roomCategory,
  ...technician,
  ...staffPosition,
  ...maintenanceIssue,
  ...roomStatus,
  ...vendor,
  ...paymentMethod,
  ...extrachargeCategory,
  ...source,
  ...roomManagement,
];
export default routes;
